import React from 'react'
import {
  CFView,
  CFText,
  CFImage,
  CFLink,
  DefaultScreen,
  MobileScreen,
} from 'components'
import Header from './Header'
import OrderPickupButton from './OrderPickupButton'
import OrderDeliveryButton from './OrderDeliveryButton'
import { hero, heroText, mobileHero, mobileHeroText } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView
          h="100vh"
          image={`url(${mobileHero}) bottom / cover no-repeat`}
          column
          alignCenter
        >
          <Header />
          <CFView w="100%">
            <CFView mt="22px">
              <CFImage
                w="85%"
                src={mobileHeroText}
                alt="Cheam Sushi Bar hero text"
                zIndex={98}
              />
            </CFView>
            <CFView textCenter mv="35px" pulsate>
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          h="700px"
          w="100%"
          image={`url(${hero}) top/ cover no-repeat`}
          zIndex={90}
          column
          justifyStart
        >
          <Header />
          <CFView column justifyCenter alignStart>
            <CFView column justifyCenter alignStart mt="80px">
              <CFImage
                w="650px"
                src={heroText}
                alt="Cheam Sushi Bar hero text"
                zIndex={98}
              />
            </CFView>
            <CFView ml="135px" mv="40px">
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
